import type { ReactNode } from "react";

export function PendingIcon(): ReactNode {
	return (
		<svg
			fill="none"
			height="8px"
			viewBox="0 0 8 7"
			width="8px"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.00024 7.5C2.64928 7.39813 2.31221 7.22959 2.00024 7M4.50024 0.5C5.3525 0.68107 6.11342 1.12594 6.65843 1.76179C7.20344 2.39763 7.50024 3.18677 7.50024 4C7.50024 4.81323 7.20344 5.60237 6.65843 6.23821C6.11342 6.87406 5.3525 7.31893 4.50024 7.5M1.00024 6C0.777956 5.69424 0.609128 5.35658 0.500244 5M0.500244 3.5C0.57508 3.02181 0.71914 2.56879 0.921198 2.15352L1.00024 2M2.00024 1C2.30275 0.7625 2.64212 0.592816 3.00024 0.5"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
